import { fetchJSON } from "../helpers/fetcher"
import { ENVIRONMENT, getEndpoint } from "./endpoints"

const subscriptionDetailsUrl = getEndpoint(ENVIRONMENT)?.subscriptionDetails as string
const activateSubscriptionUrl = getEndpoint(ENVIRONMENT)?.subscriptionActivate as string
const updateSubscriptionUrl = getEndpoint(ENVIRONMENT)?.subscriptionUpdate as string
const releaseSubscriptionScheduleUrl = getEndpoint(ENVIRONMENT)?.releaseSubscriptionSchedule as string

export class SubscriptionService {
  static getDetails = async () => {
    return await fetchJSON(subscriptionDetailsUrl, "POST")
  }

  static activate = async (body: { plan_type: string }) => {
    return await fetchJSON(activateSubscriptionUrl, "POST", body)
  }

  static update = async (body: { stripe_subscription_id: string; new_subscription_type: string }) => {
    return await fetchJSON(updateSubscriptionUrl, "POST", body)
  }

  static releaseSchedule = async (body: { subscription_schedule_id: string }) => {
    return await fetchJSON(releaseSubscriptionScheduleUrl, "POST", body)
  }
}
